import { Advertisement, AdvertisementProps } from "./Advertisement";

export { Advertisement, AdvertisementProps };
